/**
 * @Author: DJ
 * @Date:   2021-10-18 10:40:24
 * @Last Modified by:   DJ
 * @Last Modified time: 2022-06-02 14:22:12
 */
/**
 * 配送订单管理
 */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import moment from 'moment';
import { XInput, XInputNum, XSelect, XDatePicker, XOKButton, XCancelButton, XTabNav } from '@/components/xqxc_ui';
import TableContent from './components/OrderTable';
import MultiorderContent from '../multiorder';
import KeepAlive from '@/routes/KeepAlive';
import model from '@/reducers/order/distributionorder/model';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { getEnum } from '@/apis/common/index';
import * as apis from '@/apis/order/distributionorder';
import { message, Modal, Select } from 'antd';
const { confirm } = Modal;
import Statistics from '../statistics';
import http from '@/assets/api/http';

class Main extends React.Component {

    constructor(props) {
        super(props);
        this.systype = process.env.TYPE == 'OC' ? 'COMPANY' : 'ADMIN';
        let adminTabs = [
            { id: 1, label: '全部' },
            // { id: 2, label: '待支付' },
            { id: 3, label: '异常' },
            { id: 4, label: '一路多单' },
            { id: 5, label: '数据统计' },
        ];
        let companyTabs = [
            { id: 1, label: '全部' },
            // { id: 2, label: '待支付' },
            { id: 3, label: '异常' },
            // { id: 4, label: '一路多单' },
        ];
        this.state = {
            isDelay: {}, // 是否超时
            status: {}, // 状态
            type: {}, // 订单类型
            opId: {}, //运营公司
            source: {},  // 订单来源
            orderSourceEnum: [],  // 订单来源枚举
            shareLoading: false,
            tab: this.systype == 'ADMIN' ? adminTabs : companyTabs,
            curTabID: 1,  // 当前显示的Tab页ID
            thirdPartyChannel: {},  // 三方渠道
            thirdPartyChannels: [],  // 三方渠道列表
            userAccountTypeEnum: [{ code: 'USER', value: '个人账号' }, { code: 'ENTERPRISE', value: '企业账号' }],  // 下单账号类型枚举
            userAccountType: {}, // 下单账号类型
            userName: '', // 下单账号

            isZoneEnum: [{ code: '0', value: '非区域单' }, { code: '1', value: '区域单' },],
            isZone: {},
            isTransferEnum: [],
            isTransfer: {},
            listCancelReasonsList: [],
            ModalText: 'Content of the modal',
            visible: false,
            confirmLoading: false,
            setInfo:{},
            deliveryOrderId:'',
            cancelReasonId:'',
        };
    }

    componentDidMount() {

        const { history: { location: { curTabID } } } = this.props;
        if (curTabID) {
            this.setState({ curTabID });
        }
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
        // 状态枚举
        this.props.getDeliveryOrderStatus({ enumName: 'DeliveryStatusEnum' });
        // 订单类型
        this.props.getOrderDeliveryTypeEnum({ enumName: 'OrderDeliveryTypeEnum' });
        // 运营公司
        this.props.getCompanyItem({ pageSize: 10000 });
        // 订单来源枚举
        this.getOrderSourceEnum();
        this.getThirdPartyChannelsEnum();
        //转单枚举
        this.getTransferEnum()
        this.listCancelReasons();
    }

    //获取转单枚举
    getTransferEnum = () => {
        getEnum({ enumName: 'FlagEnum' }).then(res => {
            this.setState({ isTransferEnum: res.result });
        }).catch(err => {
            message.error(err.message);
        });
    }

    // 获取订单来源枚举
    getOrderSourceEnum = () => {
        getEnum({ enumName: 'OrderSourceTypeEnum' }).then(res => {
            this.setState({ orderSourceEnum: res.result });
        }).catch(err => {
            message.error(err.message);
        });
    }

    // 获取第三方渠道枚举
    getThirdPartyChannelsEnum = () => {
        apis.getThirdPartyChannelsEnum().then(res => {
            this.setState({ thirdPartyChannels: res.result });
        }).catch(err => {
            message.error(err.message);
        });
    }

    // Tab页切换
    _tabChangeHandle = (tabID) => {
        this.setState({
            curTabID: tabID,
        }, () => {
            if (tabID !== 4) {
                this._searchHandle('useCache');
            }
        });
    }
    listCancelReasons = () => {
        let query = {
            pageNum: 1,
            pageSize: 30,
            systemType: "RIDER_APP"
        };
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.CancelReasonsMisService.listCancelReasons&group=mis', query, 'POST').then((response) => {
            console.log(response);
            if (response.errCode == 0) {
                this.setState({
                    listCancelReasonsList: response.result.dataList
                })
            } else {
                message.error(response.message);
            }
        }).catch((e) => {
            message.error(e.message);
        });
    };
    _deliveryBtn = (val) => {
        console.log(val);
        let _this = this;

        confirm({
            title: '系统提示',
            content: '骑手无法通过骑手端确认送达时使用，确定送达后，正常给骑手结算配送收益，确定已送达么？',
            onOk() {
                console.log('OK');
                let query = {
                    deliveryOrderId: val.deliveryId
                };
                console.log(query);
                http('/?cmd=com.xqxc.api.pig.mis.order.DeliveryOrderManageMisService.arriveReceiver&group=mis', query, 'POST').then((response) => {
                    console.log(response);
                    if (response.errCode == 0) {
                        _this._searchHandle('useCache');
                        message.success('操作成功!');
                    } else {
                        message.error(response.message);
                    }
                }).catch((e) => {
                    message.error(e.message);
                });
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };
    _chargebackBtn = (val) => {
        console.log(val);
        console.log(val.deliveryId);
        let _this = this;
        this.setState({
            visible: true,
            deliveryOrderId: val.deliveryId,
        });
        
    };
    // 表格操作
    _tableAction = (key, type, record) => {
        const { history } = this.props;
        switch (type) {
            // 送达
            case 'delivery':
                this._deliveryBtn(record);
                break;
            // 退单
            case 'chargeback':
                this._chargebackBtn(record);
                break;
            case 'assign':
                history.push({
                    pathname: `/home/order/distributionorder/orderdetail/${record.deliveryId}/${record.lat}/${record.lng}/${record.userId}`,
                });
                break;
            // 详情
            case 'info':
                history.push({
                    pathname: `/home/order/distributionorder/orderdetail/${record.deliveryId}`,
                });
                break;
            // 操作记录
            case 'history':
                history.push({
                    pathname: `/home/order/distributionorder/orderhistory/${record.deliveryId}`,
                });
                break;
        }

    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { curTabID, pageNum, pageSize, deliveryId, riderPhone, shipperPhone, consigneePhone,
            opId, type, isDelay, status, createTimeStart, createTimeEnd, source, thirdPartyChannel, userAccountType, userName, isZone,
            isTransfer
        } = this.state;
        const query = {
            deliveryId,
            riderPhone,
            shipperPhone,
            consigneePhone,
            opId: opId.companyId,
            type: type.code,
            isDelay: isDelay.code,
            createTimeStart,
            createTimeEnd,
            orderSource: source.code,
            openApiCode: thirdPartyChannel.channelCode,
            userAccountType: userAccountType.code,
            userName,
            isZone: isZone.code,
            isTransfer: isTransfer.code,
            status: curTabID == 1 ? status.code : curTabID == 2 ? 'PAYING' : curTabID == 3 ? 'UNDELIVERED' : '',
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        if (curTabID !== 4) {
            this.props.getDeliveryOrderList(query);
        }
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize });
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({
            deliveryId: undefined, riderPhone: undefined, shipperPhone: undefined, consigneePhone: undefined,
            source: {},
            openApiCode: {},
            userAccountType: {},
            userName: undefined,
            isZone: {},
            isTransfer: {},
            opId: {}, type: {}, isDelay: {}, createTimeStart: undefined, createTimeEnd: undefined, status: {}, pageNum: 1, pageSize: 10
        }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 每页pageSize条，当前第pageNum页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }
    startDate = () => {
        this.setState({ createTimeEnd: undefined });
    }
    disabledDate = (current) => {
        const { createTimeStart } = this.state;
        let enddays = createTimeStart && moment(createTimeStart);
        return current && current < enddays && enddays.startOf('day');
    }
    deliveryIdHandle = e => {
        var value = e.target.value;
        const reg = /^[0-9a-zA-Z]*$/; // 数字、字母
        if (value && value.toString().length > 21) {
            return;
        } else if (!reg.test(value)) {
            this.setState({ deliveryId: undefined });
        }
    }
    onSourceChange = (val) => {
        if (val.code !== 'OPEN_API') {
            this.setState({ thirdPartyChannel: {} });
        }
    }
    handleChange = (value) => {
        console.log(`selected ${value}`);
        this.state.listCancelReasonsList.map((val,index)=>{
            if(val.id==value){
                this.setState({
                    cancelReasonId:val.id,
                    setInfo:{
                        deliveryOrderId: val.deliveryId,
                        cancelReasonId:val.id,
                        cancelReason:val.reason
                    }
                })
            }
        })
    }
    handleOk = () => {
        console.log(this.state.setInfo);
        if(Object.keys(this.state.setInfo).length==0){
            message.error('请选择退单原因');
            return;
        }
        let _this=this;
        this.setState({
            visible: false,
            // setInfo:{},
          });
        confirm({
            title: '系统提示',
            content: '确定无法完成配送任务时使用，退单后订单取消，退回用户支付款项，您确定要退单么？',
            onOk() {
                console.log('OK');
                let query = {
                    ..._this.state.setInfo,
                    deliveryOrderId: _this.state.deliveryOrderId,
                };
                console.log(query);
                http('/?cmd=com.xqxc.api.pig.mis.order.DeliveryOrderManageMisService.cancelDelivery&group=mis', query, 'POST').then((response) => {
                    console.log(response);
                    if (response.errCode == 0) {
                        _this._searchHandle('useCache');
                        message.success('操作成功!');
                    } else {
                        message.error(response.message);
                    }
                }).catch((e) => {
                    message.error(e.message);
                });
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }
    handleCancel = () => {
        console.log('Clicked cancel button');
        this.setState({
          visible: false,
        });
      };
    render() {
        const { deliveryId, riderPhone, shipperPhone, consigneePhone, opId, type, isDelay, status, createTimeStart, createTimeEnd,
            orderSourceEnum, source, thirdPartyChannels, thirdPartyChannel, userAccountTypeEnum, userAccountType, userName, isZoneEnum, isZone,
            isTransfer, isTransferEnum, visible, ModalText, listCancelReasonsList,cancelReasonId
        } = this.state;
        const { DeliveryOrderList, DeliveryOrderStatus, OrderDeliveryTypeEnum, CompanyItem: { dataList = [] } } = this.props;
        const systype = process.env.TYPE == 'OC' ? 'COMPANY' : 'ADMIN';
        console.log(listCancelReasonsList);
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache');
                    });
                }
            }}>
                <Modal
                    title="请选择退单原因"
                    visible={visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    {
                        Array.isArray(listCancelReasonsList)?<Select defaultValue={cancelReasonId} style={{ width: 300 }} placeholder='请选择' onChange={this.handleChange}>
                        {listCancelReasonsList.map((i, index) => {
                            return <Option key={i.id + index} value={i.id}>{i.reason}</Option>
                        })}
                    </Select>:''
                    }
                </Modal>
                <div className={styles.flexBoxContainer}>
                    <XTabNav renderData={this.state.tab} onChange={this._tabChangeHandle} activedID={this.state.curTabID} />
                    {this.state.curTabID < 4 && <div className={styles.orderContainer}>
                        <SearchBox>
                            <SearchItem>
                                <XInput
                                    label='订单号'
                                    placeholder='请输入订单号'
                                    value={deliveryId}
                                    bindThis={this}
                                    bindName='deliveryId'
                                    // min={0}
                                    // precision={0}
                                    onBlur={this.deliveryIdHandle}
                                    maxLength={21}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInputNum
                                    label='骑士账号'
                                    placeholder='请输入骑士账号'
                                    value={riderPhone}
                                    bindThis={this}
                                    bindName='riderPhone'
                                    min={0}
                                    precision={0}
                                    maxLength={11}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInputNum
                                    label='发货人手机'
                                    placeholder='请输入发货人手机'
                                    value={shipperPhone}
                                    bindThis={this}
                                    bindName='shipperPhone'
                                    min={0}
                                    precision={0}
                                    maxLength={11}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInputNum
                                    label='收件人手机'
                                    placeholder='请输入收件人手机'
                                    value={consigneePhone}
                                    bindThis={this}
                                    bindName='consigneePhone'
                                    min={0}
                                    precision={0}
                                    maxLength={11}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XDatePicker
                                    label='下单时间'
                                    value={createTimeStart}
                                    bindThis={this}
                                    bindName='createTimeStart'
                                    isFormat
                                    showTime={false}
                                    defaultTime='00:00:00'
                                    onChange={this.startDate}
                                />
                                <div className={styles.timeLine} />
                                <XDatePicker
                                    style={{ marginRight: 20 }}
                                    label=''
                                    value={createTimeEnd}
                                    bindThis={this}
                                    bindName='createTimeEnd'
                                    isFormat
                                    showTime={false}
                                    defaultTime='23:59:59'
                                    disabledDate={this.disabledDate}
                                />
                            </SearchItem>
                            {
                                systype == 'ADMIN' ? <SearchItem>
                                    <XSelect
                                        label='运营公司'
                                        placeholder='请选择运营公司'
                                        renderData={dataList}
                                        dataIndex='companyName'
                                        keyIndex='companyId'
                                        value={opId.companyName}
                                        showSearch={true}
                                        bindThis={this}
                                        bindName='opId'
                                    />
                                </SearchItem> : null
                            }
                            {this.state.curTabID == 1 && <SearchItem>
                                <XSelect
                                    label='订单状态'
                                    placeholder='请选择订单状态'
                                    renderData={DeliveryOrderStatus}
                                    dataIndex='value'
                                    keyIndex='code'
                                    value={status.value}
                                    showSearch={true}
                                    bindThis={this}
                                    bindName='status'
                                />
                            </SearchItem>}
                            <SearchItem>
                                <XSelect
                                    label='订单类型'
                                    placeholder='请选择订单类型'
                                    renderData={OrderDeliveryTypeEnum}
                                    dataIndex='value'
                                    keyIndex='code'
                                    value={type.value}
                                    showSearch={true}
                                    bindThis={this}
                                    bindName='type'
                                />
                            </SearchItem>
                            {systype == 'COMPANY' ? null : (
                                <>
                                    <SearchItem>
                                        <XSelect
                                            label='订单来源'
                                            placeholder='请选择'
                                            renderData={orderSourceEnum}
                                            dataIndex='value'
                                            keyIndex='code'
                                            value={source.value}
                                            showSearch={true}
                                            bindThis={this}
                                            bindName='source'
                                            onChange={this.onSourceChange}
                                        />
                                    </SearchItem>
                                    {source.code == 'OPEN_API'
                                        ? <SearchItem>
                                            <XSelect
                                                label='第三方渠道名称'
                                                placeholder='请选择'
                                                renderData={thirdPartyChannels}
                                                dataIndex='channelName'
                                                keyIndex='channelCode'
                                                value={thirdPartyChannel.channelName}
                                                showSearch={true}
                                                bindThis={this}
                                                bindName='thirdPartyChannel'
                                            />
                                        </SearchItem>
                                        : null
                                    }
                                    <SearchItem>
                                        <XSelect
                                            label='下单账号类型'
                                            placeholder='请选择'
                                            renderData={userAccountTypeEnum}
                                            dataIndex='value'
                                            keyIndex='code'
                                            value={userAccountType.value}
                                            showSearch={true}
                                            bindThis={this}
                                            bindName='userAccountType'
                                        />
                                    </SearchItem>
                                    <SearchItem>
                                        <XInput
                                            label='下单账号'
                                            placeholder='请输入'
                                            value={userName}
                                            bindThis={this}
                                            bindName='userName'
                                        />
                                    </SearchItem>
                                </>
                            )}
                            <SearchItem>
                                <XSelect
                                    label='订单类别'
                                    placeholder='请选择'
                                    renderData={isZoneEnum}
                                    dataIndex='value'
                                    keyIndex='code'
                                    value={isZone.value}
                                    showSearch={true}
                                    bindThis={this}
                                    bindName='isZone'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XSelect
                                    label='是否转单'
                                    placeholder='请选择'
                                    renderData={isTransferEnum}
                                    dataIndex='value'
                                    keyIndex='code'
                                    value={isTransfer.value}
                                    showSearch={true}
                                    bindThis={this}
                                    bindName='isTransfer'
                                />
                            </SearchItem>

                            <SearchItem>
                                <XSelect
                                    label='送达是否超时'
                                    placeholder='请选择送达是否超时'
                                    renderData={[{ code: 1, value: '是' }, { code: 0, value: '否' }]}
                                    dataIndex='value'
                                    keyIndex='code'
                                    value={isDelay.value}
                                    showSearch={true}
                                    bindThis={this}
                                    bindName='isDelay'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XOKButton
                                    label='查询'
                                    onClick={this._searchHandle}
                                />
                                <XCancelButton
                                    label='重置'
                                    onClick={this._resetHandle}
                                />
                            </SearchItem>
                        </SearchBox>
                    </div>}
                    {/* <ButtonPerssion code='ordermanage/valueserviceorder/dc'>
                    <div className={styles.row2}>
                        <XOKButton
                            style={{ width: 'auto' }}
                            loading={this.state.shareLoading}
                            label='生成报表'
                            onClick={this._createHandle}
                        />
                    </div>
                    </ButtonPerssion> */}
                    {this.state.curTabID < 4 ? <TableContent
                        renderData={DeliveryOrderList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    /> : null}
                    {this.state.curTabID == 4 ? <MultiorderContent history={this.props.history} /> : null}
                    {this.state.curTabID == 5
                        ? <Statistics
                            OrderDeliveryTypeEnum={OrderDeliveryTypeEnum}
                            history={this.props.history}
                            orderSourceEnum={orderSourceEnum}
                            thirdPartyChannels={thirdPartyChannels}
                            companyList={dataList}
                        />
                        : null}
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object, // 路由
    match: PropTypes.object,
    getDeliveryOrderList: PropTypes.func,
    DeliveryOrderList: PropTypes.object,
    getDeliveryOrderStatus: PropTypes.func,
    DeliveryOrderStatus: PropTypes.array,
    getOrderDeliveryTypeEnum: PropTypes.func,
    OrderDeliveryTypeEnum: PropTypes.array,
    getCompanyItem: PropTypes.func,
    CompanyItem: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,
};
const mapStateToProps = (state) => ({
    DeliveryOrderList: state.distributionorder.DeliveryOrderList,
    DeliveryOrderStatus: state.distributionorder.DeliveryOrderStatus,
    OrderDeliveryTypeEnum: state.distributionorder.OrderDeliveryTypeEnum,
    CompanyItem: state.distributionorder.CompanyItem,
});
export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);